import React, { Fragment } from 'react';
import { connect } from "react-redux";
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Modal from '@material-ui/core/Modal';
import ModalHeading from '../ModalHeading';
import ButtonContent from '../ButtonContent';
import { withStyles, styled } from '@material-ui/core/styles';
import Badge from '@material-ui/core/Badge';
import withAuth from '../../hocs/withAuth';
import { COLORS } from '../../styles/colors'
import AddIcon from '@material-ui/icons/Add';
import { Link } from "react-router-dom";
import ScheduleMessageListing from './../assignments/ScheduleMessageListing';
import ScheduleCalendar from './../assignments/ScheduleCalendar';


const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: -9,
        top: 0,
        backgroundColor: 'rgb(234, 94, 1)',
        fontSize: '10px'
    },
}));

class ScheduleMessgage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            show: props.isOpenAddModal,
            formData: {
                title: ''
            },
            selectedTab: this.props.isMobile ? 'scheduled' : 'scheduled',
            actions: [],
            isOpenForm: false,
            isOpenViewAction: false,
            scheduleCount: 0,
            completeCount: 0
        }
        this.prepareData = [];
    }

    selectedTab = (path) => {
        this.setState({
            selectedTab: path
        })
    }

    
    makeid(length) {
        var result = '';
        var characters = '0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    
    onClose = () => this.setState({ show: false }, () => this.props.hideActionModal());

    
    renderTabs = () => {

        let links = [
            { text: 'Scheduled ', path: 'scheduled' },
            { text: 'Completed ', path: 'completeMessage' },
            { text: 'Calender', path: 'calender' },
        ]

        if(this.props.isMobile) {
            links = [
                { text: 'Scheduled', path: 'scheduled' },
                 { text: 'Calender', path: 'calender' },
            ]
        }

        return(<div style={{ width: '100%', borderBottom: '1px solid ' + COLORS.grey, paddingBottom: 6, marginBottom: 20 }}>
              {
                links.map((link, i) => (
                  <a key={i} >
                    <span style={{
                      color: COLORS.black,
                      padding: 6,
                      marginRight: 25,
                      borderBottom: this.state.selectedTab === link.path ? '5px solid ' + COLORS.orange : ''
                    }} onClick={() => this.selectedTab(link.path)}>
                      { link.path !== 'calender' ?
                        <StyledBadge
                            badgeContent={link.path === 'scheduled'?  
                                            this.state.scheduleCount :
                                            this.state.completeCount
                                        }
                            color="secondary"
                        >
                             {link.text}
                        </StyledBadge> : link.text
                      }
                     
                    </span>
                  </a>
                ))
              }
        </div>)
    }

    
    viewHistory = () => {
        this.setState({
           isOpenViewAction: !this.state.isOpenViewAction
        })
    }

    updateMessagesCount = (messageData) => {
        this.setState({
            scheduleCount: messageData.scheduleCount,
            completeCount: messageData.completeCount
        })
    }

    
    render() {
        let { clientType, isMobile } = this.props;
        const { show, isOpenForm, actionType, formData, actions, isOpenViewAction, selectedTab } = this.state;
        return (
            <Modal
                className="modal show"
                open={show}
                onClose={this.onClose}
            >
                <div className="modalBody modal-content" style={{ width: isMobile ? '90%' : 850, minHeight: isMobile ? 400 : 600 }}>
                        <Fragment>
                            <ModalHeading
                                text={'Schedule Message'}
                                closeModal={this.onClose}
                            />
                            <div className="modalContent">
                                
                                {this.renderTabs()}
                                {
                                    selectedTab === 'scheduled' ?
                                    <ScheduleMessageListing 
                                        fetchScheduleMessages = { this.props.fetchScheduleMessages} 
                                        clientEmail = {this.props.clientEmail}
                                        deleteScheduleMessage = { this.props.deleteScheduleMessage } 
                                        fetchScheduleMessageDetail = { this.props.fetchScheduleMessageDetail  } 
                                        saveScheduleMessage = { this.props.saveScheduleMessage }
                                        user = {this.props.user}
                                        isMobile = { this.props.isMobile }
                                        isSent = { false }
                                        updateMessagesCount = { this.updateMessagesCount }
                                    >
                                    </ScheduleMessageListing>

                                  : selectedTab === 'completeMessage' ?
                                    <ScheduleMessageListing 
                                        fetchScheduleMessages = { this.props.fetchScheduleMessages} 
                                        clientEmail = {this.props.clientEmail}
                                        deleteScheduleMessage = { this.props.deleteScheduleMessage } 
                                        fetchScheduleMessageDetail = { this.props.fetchScheduleMessageDetail  } 
                                        saveScheduleMessage = { this.props.saveScheduleMessage }
                                        user = {this.props.user}
                                        isMobile = { this.props.isMobile }
                                        updateMessagesCount = { this.updateMessagesCount }
                                        isSent = { true }
                                    />:
                                       <ScheduleCalendar  clientEmail = {this.props.clientEmail}
                                            user = {this.props.user}
                                            fetchScheduleMessages = { this.props.fetchScheduleMessages }
                                            saveScheduleMessage = {this.props.saveScheduleMessage}
                                            fetchScheduleMessageDetail = {this.props.fetchScheduleMessageDetail}
                                            deleteScheduleMessage = {this.props.deleteScheduleMessage}
                                            isMobile = {this.props.isMobile}
                                        />
                                }
                             </div>
                        </Fragment>
                </div>
            </Modal>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        errors: state.errors
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {

    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withAuth(ScheduleMessgage));



// WEBPACK FOOTER //
// ./src/components/assignments/ScheduleMessage.js